export default "__VITE_ASSET__De8ubnRN__"